import React from 'react';

const SelectGroup = ({ data: { label } }) => {
    return (
        <div className="Select__group">
            <div className="Select__group-heading">{label}</div>
        </div>
    );
};

export default SelectGroup;
